
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/car-rent",
      function () {
        return require("private-next-pages/services/car-rent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/car-rent"])
      });
    }
  